<ng-content />
@if (controlType() === 'radio') {
	<vp-selection-card-radio
		[customFormControl]="customFormControl()"
		[grid]="grid()"
		[hasCardsAsMarkdown]="hasCardsAsMarkdown()"
		[hasError]="hasError()"
		[hideNativeInput]="hideNativeInput()"
		[isDisabled]="isDisabled()"
		[isReadonly]="isReadonly()"
		[isValid]="isValid()"
		[name]="name()"
		[stacked]="stacked()"
		[(options)]="options"
	/>
} @else if (controlType() === 'checkbox') {
	<vp-selection-card-checkbox
		[customFormControl]="customFormControl()"
		[grid]="grid()"
		[hasCardsAsMarkdown]="hasCardsAsMarkdown()"
		[hasError]="hasError()"
		[hideNativeInput]="hideNativeInput()"
		[isDisabled]="isDisabled()"
		[isReadonly]="isReadonly()"
		[isValid]="isValid()"
		[name]="name()"
		[stacked]="stacked()"
		[(options)]="options"
	/>
}
